import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export default function withRouter(Component) {
	function ComponentWithRouterProp(props) {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const history = {
			push: navigate,
			replace: (to) => navigate(to, { replace: true }),
			goBack: () => navigate(-1),
		};
		const match = { params, url: location.pathname, path: location.pathname, isExact: true };
		return <Component {...props} location={location} navigate={navigate} history={history} match={match} params={params} />;
	}

	const displayName = Component.displayName || Component.name || 'Component';
	ComponentWithRouterProp.displayName = `withRouter(${displayName})`;
	return ComponentWithRouterProp;
}
